var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSection',{attrs:{"id":"import-settings","title":_vm.$getConst.pages.import_settings.import_settings_title,"type":"section"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }